import { forwardRef, useEffect, useRef } from "react";
import './MissionVisionValuesSlide.css';
import Card from '../../Card/Card';
import Bullseye from "../../animations/Bullseye";
import Eye from "../../animations/Eye";
import Handshake from "../../animations/Handshake";
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger';
import Box from "@mui/material/Box/Box";

gsap.registerPlugin(ScrollTrigger);

const MissionVisionValuesSlide = forwardRef((_, __) => {
  const ref = useRef<HTMLDivElement>(null);
  const missionRef = useRef<HTMLDivElement>(null);
  const visionRef = useRef<HTMLDivElement>(null);
  const valuesRef = useRef<HTMLDivElement>(null);

  return (
    <Box className="content-slide" id="mission-vision-values" ref={ref}>
      <Card className="mvv-card" id="mission" titleString="Mission" animation={Bullseye} width="100%" ref={missionRef}>
        To maintain through innovation and technology, a high level of quality service that ensures product and service is second to none in the industry with the best solution for complex high accuracy components providing value for generations to come. We will strive to continually improve the quality of our product and service within a safe working environment in a manner that is responsive, accessible, and profitable.
      </Card>
      <Card className="mvv-card" id="vision" titleString="Vision" animation={Eye} width="100%" ref={visionRef}>
        To be recognized as a Leading Canadian Manufacturer of precision machined parts.
      </Card>
      <Card className="mvv-card" id="values" titleString="Values" animation={Handshake} width="100%" ref={valuesRef}>
        <ul>
          <li>Executive Leadership</li>
          <li>Customer Centric</li>
          <li>Safety and Reassurance</li>
          <li>Employee Knowledge Base</li>
          <li>Quality Driven</li>
          <li>Attention to Detail</li>
          <li>Commitment to Precision</li>
        </ul>
      </Card>
    </Box>
  )
});

export default MissionVisionValuesSlide